/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import ArticleMapper from '@intercom/billing-core/article-distribution-mapper';

import {
  PRICING_5_0_EARLY_STAGE_FREE_PRICING_MODEL,
  PRICING_5_0_EARLY_STAGE_PRICING_MODEL,
  PRICING_5_1_COPILOT_EARLY_STAGE_FREE_PRICING_MODEL,
  PRICING_5_1_COPILOT_EARLY_STAGE_PRICING_MODEL,
  PRICING_5_1_EARLY_STAGE_FREE_PRICING_MODEL,
  PRICING_5_1_EARLY_STAGE_PRICING_MODEL,
} from 'embercom/lib/billing';

export default class ArticleService {
  private static articleMapper = new ArticleMapper();

  // Convert the method to an instance method (not static)
  static getArticle(articleName: string, app: $TSFixMe, customerService: $TSFixMe) {
    if (!app) {
      console.warn('Customer or App not found. Defaulting to fallback article.');
      return this.articleMapper.getArticle(articleName, {}); // Empty context, will return default article
    }

    let context = {
      isStandaloneApp: app.isStandaloneApp,
      isAppPPP: app.canUsePerProductPricingFlow,
      isAppVBP: app.isOnValueBasedPricing,
      isAppPricing5: app.onPricing5,
      usesResolutionsWithCustomAnswers: app.usesResolutionsWithCustomAnswers,
      isPricing5_0_EarlyStagePricingModel:
        customerService.currentPricingModelIdentifier === PRICING_5_0_EARLY_STAGE_PRICING_MODEL,
      isPricing5_0_EarlyStageFreePricingModel:
        customerService.currentPricingModelIdentifier ===
        PRICING_5_0_EARLY_STAGE_FREE_PRICING_MODEL,
      isPricing5_1_EarlyStagePricingModel:
        customerService.currentPricingModelIdentifier === PRICING_5_1_EARLY_STAGE_PRICING_MODEL,
      isPricing5_1_EarlyStageFreePricingModel:
        customerService.currentPricingModelIdentifier ===
        PRICING_5_1_EARLY_STAGE_FREE_PRICING_MODEL,
      isPricing5_1_CopilotEarlyStagePricingModel:
        customerService.currentPricingModelIdentifier ===
        PRICING_5_1_COPILOT_EARLY_STAGE_PRICING_MODEL,
      isPricing5_1_CopilotEarlyStageFreePricingModel:
        customerService.currentPricingModelIdentifier ===
        PRICING_5_1_COPILOT_EARLY_STAGE_FREE_PRICING_MODEL,
    };

    return this.articleMapper.getArticle(articleName, context);
  }

  static getResponsibleTeam(articleName: string) {
    return this.articleMapper.getResponsibleTeam(articleName);
  }
}
